import React from 'react'
import { pendingDocIcon } from 'src/designSystem/icons'
import IndicatorTooltip from './IndicatorTooltip'

export const MonthlySummaryIndicator = () => (
  <IndicatorTooltip title="Pending monthly summary doc">
    <img src={pendingDocIcon} alt="Pending monthly summary doc" />
  </IndicatorTooltip>
)
